module.exports = __webpack_public_path__ + "static/media/Aqi-Unhealthy.5f974397.png";